import type { DateFormatPref } from "@heraion/shared";
import type { DateFormatStorage } from "@heraion/ui";

// #390: the date format, per browser, next to the language (`jl.lang`): its
// `auto` default is this device's region, so it cannot ride the profile.
const KEY = "jl.dateFormat";

export const dateFormatStorage: DateFormatStorage = {
  read: () => {
    try {
      return window.localStorage.getItem(KEY);
    } catch {
      return null;
    }
  },
  write: (value: DateFormatPref) => {
    try {
      window.localStorage.setItem(KEY, value);
    } catch {
      /* private mode: the choice holds for this session only */
    }
  },
};

/** The browser's region, which `auto` follows. */
export const browserLocale = (): string | null =>
  typeof navigator === "undefined" ? null : navigator.language || null;
